module.exports = __webpack_public_path__ + "img/double-opt-in-2.7832513e.png";